import { useAppSelector } from "@/services/store";
import { useCallback } from "react";
import { Permission, PermissionMapping } from "./permissions.utils";

/**
 * Returns true if user has any of the supplied permissions
 * @param permission
 * @param groups
 */
const permissionLookup = (permission: Permission | Permission[], groups: string[]) => {
  const permissions = !Array.isArray(permission) ? [permission] : permission;
  for (const p of permissions) {
    if (groups.includes(PermissionMapping[p])) {
      return true;
    }
  }
  return false;
};
/**
 * Returns true if user has any of the supplied permissions
 * @param permission
 * @param ignoreSuper - If true, super_admin will not be considered as having all permissions
 */
export const useHasPermission = (permission: Permission | Permission[], ignoreSuper: boolean = false): boolean => {
  const groups = useAppSelector(state => state.auth.groups) ?? [];
  if (!ignoreSuper && groups.includes("super_admin")) {
    return true;
  }
  return permissionLookup(permission, groups);
};

export const usePermission = () => {
  const groups = useAppSelector(state => state.auth.groups) ?? [];
  const hasPermission = useCallback(
    (permission: Permission | Permission[]) => permissionLookup(permission, groups),
    [groups],
  );
  return {
    hasPermission,
  };
};
